import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEvent3DMockup = (action: "mockup_show" | "mockup_click" | "floor" | "property_click") => {
    hitGoogleTagManager({
        event: "3d_mockup",
        projecttion_planner_action: action
    });
};
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export const gtmEvent3DMockup = (action: "mockup_show" | "mockup_click" | "floor" | "property_click") => {
    hitGoogleTagManager({
        event: "3d_mockup",
        projecttion_planner_action: action
    });
};
